import type { MessageKey } from "../../i18n/dictionaries";
import type { CustomerDecision } from "./types";

// The customer's response value → its (Turkish-first) label key. Shared by the
// detail panel and the pending-responses worklist so the wording is decided once.
export const RESPONSE_LABEL_KEY: Record<CustomerDecision, MessageKey> = {
  ACCEPTED: "rec.response.ACCEPTED",
  DECLINED: "rec.response.DECLINED",
  DEFERRED: "rec.response.DEFERRED",
};

/** Display the ISO respondedAt as a plain YYYY-MM-DD (deterministic, locale-free). */
export function responseDate(respondedAt: string): string {
  return respondedAt.slice(0, 10);
}
